import { Box, Typography } from '@mui/material';
import { PricelistMailSendoutResult } from '../../common/PricePrgClient';
import { toDateString, toDateTimeString } from '../../utils';

type Props = {
    sendoutResult?: PricelistMailSendoutResult;
};

export const LatestPricelistMailSendoutInfo = ({ sendoutResult }: Props) => {
    if (sendoutResult == null) {
        return null;
    }

    const { type, createdDate, pricelistDate, purchaser, sentByUser, sentToEmail } = sendoutResult;
    return (
        <div>
            <Typography variant="subtitle2">{type}</Typography>
            <Box sx={{ fontSize: 12, color: 'gray' }}>{`Pricelist with date ${toDateString(
                pricelistDate
            )} sent out at ${toDateTimeString(createdDate)} by ${sentByUser}${
                sentToEmail != null ? ` to ${sentToEmail}` : ''
            }${purchaser != null ? `, filtered by purchaser ${purchaser}` : ''}`}</Box>
        </div>
    );
};
